export const LEARN_HUB_PLAYBOOK = {
  when: [
    { label: 'New subject', text: 'Create a notebook before each course or exam.' },
    { label: 'After class', text: 'Import PDFs or notes while fresh.' },
    { label: 'Daily', text: 'Study cards here; Review on Study hub.' },
  ],
  how: [
    { label: 'Create', text: 'One notebook per topic.' },
    { label: 'Import', text: 'PDF, URL, or paste on the notebook page.' },
    { label: 'Study', text: 'Read Q&A and save for Review.' },
  ],
  what: [
    { label: 'Notebooks', text: 'Your content and import jobs.' },
    { label: 'Catalog', text: 'Subscribe to public notebook lists.' },
    {
      label: 'Library',
      text: 'Shared Q&A at',
      link: { to: '/library', label: '/library' },
    },
  ],
};
